import { Injectable } from '@angular/core';
import { Firestore, collection, addDoc } from '@angular/fire/firestore';
import {
  Storage,
  ref,
  uploadBytes,
  getDownloadURL,
} from '@angular/fire/storage'; // Add Storage imports

@Injectable({
  providedIn: 'root',
})
export class FirestoreService {
  // Inject BOTH services here
  constructor(
    private firestore: Firestore,

    private storage: Storage,
  ) {}

  // Save data to Firestore
  async addData(collectionName: string, data: any): Promise<void> {
    const collRef = collection(this.firestore, collectionName);
    try {
      await addDoc(collRef, data);
      console.log('Document added successfully');
    } catch (error) {
      console.error('Error adding document: ', error);
      throw error; // Rethrow so the component can handle the error
    }
  }

  // Upload file to Storage and return URL
  async uploadFile(path: string, file: File): Promise<string> {
    try {
      // Create a reference to the storage path
      const storageRef = ref(this.storage, path);

      // Upload the bytes
      const snapshot = await uploadBytes(storageRef, file);

      // Get and return the public download URL
      return await getDownloadURL(snapshot.ref);
    } catch (error) {
      console.error('Upload failed:', error);
      throw error;
    }
  }
}
